import _ from 'lodash'
import { FC } from 'react'
import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { isUS } from 'env'
import { FormikFieldsType } from 'modules/domain/types'

const FRACTION_DIGITS = 1
const KG_IN_BAG = 60

type Value = string | number | undefined

export const formatQuantityNumber = (value: Value): number => parseFloat(Number(value).toFixed(FRACTION_DIGITS))
export const tonsToBags = (tons: Value): number => formatQuantityNumber((Number(tons) * 1000) / KG_IN_BAG)
export const bagsToTons = (bags: Value): number => formatQuantityNumber((Number(bags) * KG_IN_BAG) / 1000)

type Props = {
  formik: FormikFieldsType
  disabled?: boolean
  required?: boolean
  fieldName: string
  label: string
}

export const QuantityInput: FC<Props> = ({ formik, fieldName, label = '', required = false, disabled }) => {
  const { t } = useTranslation('common')

  const error = _.get(formik.errors, fieldName)

  const inputProps = formik.getFieldProps(fieldName)

  return (
    <>
      <FormGroup label={`${label}, ${isUS ? t('bsh') : t('t')}`} error={error} required={required}>
        <Input {...inputProps} invalid={!!error} type="number" min={0} disabled={disabled} />
      </FormGroup>
    </>
  )
}
